import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import ChurchIcon from '@mui/icons-material/Church';
import FlatwareIcon from '@mui/icons-material/Flatware';
import CelebrationIcon from '@mui/icons-material/Celebration';
import TramIcon from "@mui/icons-material/Tram";
import { useT } from 'talkr';
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";


export default function CustomizedTimeline() {

  const { T } = useT();

  const timeLineItems = [
    {
      time: "14:30",
      icon: <ChurchIcon/>,
      text: T("program_list.wedding_ceremony"),
    },
    {
      time: "17:00",
      icon: <TramIcon/>,
      text: T("program_list.party_tram"),
    },
    {
      time: "17:30",
      icon: <FlatwareIcon/>,
      text: T("program_list.wedding_dinner"),
    },
    {
      time: "21:00",
      icon: <CelebrationIcon/>,
      text: T("program_list.party"),
    },
    {
      time: "05:30",
      icon: <WbSunnyOutlinedIcon/>,
      text: T("program_list.sunrise_welcome"),
    },
  ];


  return (
    <Timeline>
      {timeLineItems.map((item, index) => (
        <TimelineItem key={index}>
          <TimelineOppositeContent sx={{ m: "auto 0", fontWeight: "medium" }}>
            {item.time}
          </TimelineOppositeContent>
          <TimelineSeparator>
            {index !== 0 && <TimelineConnector/>}
            <TimelineDot sx={{ backgroundColor: "primary.main" }} variant="filled">{item.icon}</TimelineDot>
          </TimelineSeparator>
          <TimelineContent sx={{ m: "auto 0" }}>
            <Typography sx={{ fontWeight: "medium" }}>{}{item.text}</Typography>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}